export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_2.3-2b35d5cd1fa3de0eb49d2e6ee6817fc0.svg";